/**
 * Bande de tête du contenu — téléphone (U6b vague 9, planche CoquilleTelephone, zone 4) :
 * le lien retour « ‹ Entrée » (ou le titre de l'écran) et la pastille N28 « Prochaine action › »,
 * jamais tronquée. Masquée dès 768 px, où le fil et N28 sont dans la barre haute.
 */
import type { JSX } from 'react'
import { useLocation } from 'react-router-dom'

import { FilAriane } from '@/components/FilAriane'
import { ProchaineAction } from '@/components/ProchaineAction'
import { niveauDuChemin } from '@/lib/nav'
import { useWorkspace } from '@/hooks/useWorkspace'

export function BandeTelephone(): JSX.Element {
  const { pathname, search } = useLocation()
  const { activeId } = useWorkspace()
  const projet = niveauDuChemin(pathname, search) === 'projet' && Boolean(activeId)
  return (
    <div data-testid="bande-telephone" className="mb-3 flex min-w-0 items-center gap-2 md:hidden">
      <FilAriane partie="telephone" />
      {projet ? <ProchaineAction workspaceId={activeId} variante="pastille" /> : null}
    </div>
  )
}
